export default __webpack_public_path__ + "d01d45e64be4d138421f455ddfe8451b.svg";